import {
  Lit3formBlock,
  html,
  unsafeHTML,
  ifDefined,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';

import '@Helpers/vimeo-video';

export class Rocky extends Lit3formBlock {
  static get characterName() {
    return 'rocky';
  }

  static get characterProperties() {
    return {
      description: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid rocky-layout">
          ${this.videoId
            ? html`
                <div class="video media">
                  <div class="vimeo-wrapper">
                    <vimeo-video videoid="${this.videoId}"></vimeo-video>
                  </div>
                </div>
              `
            : html`
                <div class="image media">
                  <a
                    href=${ifDefined(
                      this.hasCta ? this.content.cta.url : undefined
                    )}
                  >
                    <img src="${this.imageUrl}" />
                  </a>
                </div>
              `}
          ${this.showImageDescription
            ? html`
                <p class="image-description description">
                  ${unsafeHTML(this.withLineBreaks(this.imageDescription))}
                </p>
              `
            : html``}
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get hasCta() {
    return this.content.cta && !!this.content.cta.text;
  }

  get videoId() {
    if (!!this.content.video_url && this.content.video_url.includes('vimeo')) {
      return this.content.video_url.match(
        /^https?:\/\/(?:.*?)\.?(vimeo)\.com\/(\d+).*$/
      )[2];
    } else {
      return '';
    }
  }

  get imageUrl() {
    return !!this.content.image
      ? this.imagebossUrl(this.content.image.src, 1500, null)
      : '';
  }

  get showImageDescription() {
    return this.content.show_image_description && this.hasImageDescription;
  }

  get hasImageDescription() {
    return this.content?.image && this.content?.image?.description;
  }

  get imageDescription() {
    return this.content?.image?.description;
  }
}
Rocky.defineElement();
